import React from "react";

export default function CenterManagerOverview({ trainers, batches, learners }) {
  return <section className="report-grid" data-testid="center-manager-overview"><article><span>Trainers</span><strong>{trainers.length}</strong></article><article><span>Batches</span><strong>{batches.length}</strong></article><article><span>Learners</span><strong>{learners.length}</strong></article></section>;
}